module.exports = __webpack_public_path__ + "img/stock5.11cf3780.png";